import { supabase } from './supabase';
import { parseRetention, type NetworkRetention } from './retention';

/**
 * Rétention réseau (brique F) — lecture via RPC sécurisée `network_retention`
 * (super_admin only, cf. sql/27_retention.sql). Logique pure dans retention.ts.
 */

export interface LoadRetentionResult {
  ok: boolean;
  data: NetworkRetention;
  error?: string;
}

const EMPTY: NetworkRetention = { windowDays: 30, tenants: [], dormantCustomers: 0, loyalCustomers: 0 };

/** Charge la rétention réseau sur `days` jours (vs les `days` précédents). */
export async function loadRetention(days = 30): Promise<LoadRetentionResult> {
  const { data, error } = await supabase.rpc('network_retention', { p_days: days });
  if (error) {
    return { ok: false, data: EMPTY, error: error.message };
  }
  return { ok: true, data: parseRetention(data) };
}
